<template>
	<div class="">
		<div class="case-pice"><span class="case-pice-first">会员单位管理</span> <span class="case-pice-and">/</span> <span class="case-pice-second">会员单位资料详情</span></div>
		<div class="common-title">
			会员单位信息
		</div>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content company-title">{{signUpData.companyName}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">统一社会代码：{{signUpData.creditCode}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content company-text">所属区县：{{signUpData.provinceName}} - {{signUpData.countyName}} - {{signUpData.cityName}} </div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">营业执照地址：{{signUpData.businessAddress}}</div>
			</el-col>
		</el-row>
		<el-row :gutter="40" id='imgTooles'>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.businessLicenseImg' :src="signUpData.businessLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					营业执照
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.vipFormImg' :src="signUpData.vipFormImg" alt="" />
				</div>
				<div class="grid-text">
					会员单位申请表
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.transportLicenseImg' :src="signUpData.transportLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					道路运输许可证
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import Viewer from 'viewerjs';
	import { getDetailCompany } from '../../api/main'
	export default {
		data() {
			return {
				signUpData: {},
			}
		},
		mounted() {
			this.getDetail();

		},
		methods: {
			preImage() {
				const ViewerDom = document.getElementById('imgTooles');
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			getDetail() {
				getDetailCompany(this.$store.state.memberPageId).then(res => {
					this.signUpData = res.data;
				})
			},
			goBack() {
				this.$router.go(-1);
			}
		}
	}
</script>

<style lang="less">
	.company-change-detail {
		font-size: 16px;
	}
</style>